import React from 'react';
import { Clock, ArrowRight, Home } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';

const ComingSoon = () => {
  const navigate = useNavigate();

  const handleHomeClick = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow bg-gradient-to-br from-[#E8EEF6] to-white">
        <div className="flex items-center justify-center min-h-[calc(100vh-160px)] px-4 sm:px-6 py-24">
          <div className="max-w-2xl mx-auto text-center relative">
            {/* Main Content Container */}
            <div className="bg-white rounded-2xl sm:rounded-3xl shadow-lg p-6 sm:p-8 md:p-10 border border-[#E6E6E6]">
              
              {/* Icon and Animation */}
              <div className="mb-6">
                <div className="inline-flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br from-[#113262] to-[#1C52A0] rounded-full mb-4 animate-pulse">
                  <Clock className="w-8 h-8 sm:w-10 sm:h-10 text-white" />
                </div>
              </div>

              {/* Main Heading */}
              <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold text-[#113262] mb-3 leading-tight">
                Coming Soon
              </h1>

              {/* Subheading */}
              <p className="text-base sm:text-lg md:text-xl text-[#1C52A0] mb-4 font-medium">
                We're Working on Something Amazing
              </p>

              {/* Description */}
              <p className="text-sm sm:text-base text-[#545454] leading-relaxed mb-6">
                This page is currently under development. We're crafting an exceptional experience 
                that aligns with our commitment to transparency and innovation.
              </p>

              {/* Decorative Elements */}
              <div className="flex items-center justify-center space-x-2 mb-6">
                <div className="w-2 h-2 sm:w-3 sm:h-3 bg-[#F49611] rounded-full animate-bounce"></div>
                <div className="w-2 h-2 sm:w-3 sm:h-3 bg-[#1C52A0] rounded-full animate-bounce" style={{ animationDelay: '0.1s' }}></div>
                <div className="w-2 h-2 sm:w-3 sm:h-3 bg-[#7B9BC8] rounded-full animate-bounce" style={{ animationDelay: '0.2s' }}></div>
              </div>

              {/* Call to Action */}
              <div className="bg-gradient-to-r from-[#E8EEF6] to-[#FEF5E7] rounded-xl p-4 sm:p-6 mb-6">
                <h3 className="text-lg sm:text-xl font-semibold text-[#113262] mb-2">
                  Continue Exploring Maxiom
                </h3>
                <p className="text-sm sm:text-base text-[#545454] mb-4">
                  Discover our portfolio management services and investment philosophy while we work on this page.
                </p>
                
                <button
                  onClick={handleHomeClick}
                  className="inline-flex items-center justify-center bg-gradient-to-r from-[#F49611] to-[#AB690C] text-white px-6 py-3 sm:px-8 sm:py-4 rounded-lg sm:rounded-xl font-semibold text-sm sm:text-base hover:from-[#AB690C] hover:to-[#955C0A] transform hover:-translate-y-1 hover:shadow-lg transition-all duration-300 w-full sm:w-auto"
                >
                  <Home className="w-4 h-4 sm:w-5 sm:h-5 mr-2" />
                  Back to Home
                  <ArrowRight className="w-4 h-4 sm:w-5 sm:h-5 ml-2" />
                </button>
              </div>

              {/* Additional Info */}
              <div className="border-t border-[#E6E6E6] pt-4">
                <p className="text-xs sm:text-sm text-[#8A8A8A]">
                  Have questions?{' '}
                  <a 
                    href="/contact-us" 
                    className="text-[#1C52A0] hover:text-[#113262] font-medium underline transition-colors duration-300"
                  >
                    Contact us
                  </a>
                  {' '}or explore our other services.
                </p>
              </div>
            </div>

            
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ComingSoon;